/*
  tmc-vag-pdp.js — the one behaviour the Vaginal PDP a-top sections own themselves: the 390 pager dots
  under the organism tiles (board 2EKO-0, NW-40). A copy of tmc-gut-pdp.js (NW-37) with its own data
  hooks, so the two pages cannot bind each other's rows.

  Everything else on these sections is either CSS or already owned by assets/tmc-product.js (panel
  selection, gallery stage, the hand-off to the frozen patient-details form) and is not duplicated here.

  Progressive: the tile row is a scroll container in CSS, so it swipes whether or not this file runs.
  All this does is mirror which tile the row has reached onto the dots. It binds on shopify:section:load
  as well as DOMContentLoaded so the theme editor gets the behaviour after a re-render.
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.vpdpOrgBound === '1') return;
    var track = root.querySelector('[data-tmc-vpdp-track]');
    var pager = root.querySelector('[data-tmc-vpdp-pager]');
    if (!track || !pager) return;

    var dots = Array.prototype.slice.call(pager.children);
    var tiles = Array.prototype.slice.call(track.children);
    if (dots.length === 0 || tiles.length === 0) return;
    root.dataset.vpdpOrgBound = '1';

    function mark(index) {
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }

    /* The tile nearest the left edge of the scroll port is the one being read. offsetLeft and
       scrollLeft are read rather than getBoundingClientRect: both are cheap and neither forces a
       layout flush mid-scroll, which matters on a touch drag. Both are relative to the same
       offsetParent, so the arithmetic holds inside the theme editor's frame too. */
    function nearest() {
      var origin = track.offsetLeft + track.scrollLeft;
      var nearestIndex = 0;
      var smallestGap = Infinity;
      tiles.forEach(function (tile, i) {
        var gap = Math.abs(tile.offsetLeft - origin);
        if (gap < smallestGap) { smallestGap = gap; nearestIndex = i; }
      });
      return nearestIndex;
    }

    /* Updated straight from the scroll event, with no requestAnimationFrame coalescing. An earlier
       version guarded with a "frame already queued" boolean, which strands: requestAnimationFrame
       does not fire while the document is hidden, so one scroll in a backgrounded tab left the flag
       true and the pager never updated again for the life of the page. Five integer reads per event
       is cheaper than the bug. */
    track.addEventListener('scroll', function () {
      mark(nearest());
    }, { passive: true });

    mark(nearest());
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-tmc-vpdp-org]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
